import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

// Данные о животных
const dataSource = [
  {
    key: 0,
    region: "Чуйская",
    counts: {
      Птицы: 2724210,
      КРС: 314181,
      Коровы: 149421,
      Лошади: 75931,
      Овцы: 660049,
      Свиньи: 24356,
    },
  },
  {
    key: 1,
    region: "Баткенская",
    counts: {
      Птицы: 265104,
      КРС: 144851,
      Коровы: 69878,
      Лошади: 6763,
      Овцы: 415756,
      Свиньи: 68,
    },
  },
  {
    key: 2,
    region: "Ошская",
    counts: {
      Птицы: 103838,
      КРС: 397288,
      Коровы: 199253,
      Лошади: 98572,
      Овцы: 1121452,
      Свиньи: 0,
    },
  },
  {
    key: 3,
    region: "Таласская",
    counts: {
      Птицы: 261790,
      КРС: 314181,
      Коровы: 33965,
      Лошади: 28604,
      Овцы: 565146,
      Свиньи: 75,
    },
  },
  {
    key: 4,
    region: "Нарынская",
    counts: {
      Птицы: 213064,
      КРС: 207043,
      Коровы: 93366,
      Лошади: 142493,
      Овцы: 1127887,
      Свиньи: 0,
    },
  },
  {
    key: 5,
    region: "Ыссык-Кульская",
    counts: {
      Птицы: 624745,
      КРС: 272647,
      Коровы: 138616,
      Лошади: 94258,
      Овцы: 917653,
      Свиньи: 1106,
    },
  },
  {
    key: 6,
    region: "Джалал-Абадская",
    counts: {
      Птицы: 1188737,
      КРС: 371686,
      Коровы: 198462,
      Лошади: 94258,
      Овцы: 919653,
      Свиньи: 118,
    },
  },
  {
    key: 7,
    region: "г.Бишкек",
    counts: {
      Птицы: 12410,
      КРС: 383,
      Коровы: 259,
      Лошади: 211,
      Овцы: 1650,
      Свиньи: 17,
    },
  },
  {
    key: 8,
    region: "г.Ош",
    counts: {
      Птицы: 37492,
      КРС: 5691,
      Коровы: 2316,
      Лошади: 424,
      Овцы: 17198,
      Свиньи: 0,
    },
  },
];

// Преобразование данных для графика
const chartData = dataSource.map(item => ({
  region: item.region,
  ...item.counts
}));

const KRCandMRCChartSecond = () => {
  return (
    <div >
      <h2>Данные по регионам</h2>
      <BarChart
        width={800}
        height={400}
        data={chartData}
        margin={{
          top: 5, right: 30, left: 20, bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="region" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="Птицы" fill="#8884d8" />
        <Bar dataKey="КРС" fill="#82ca9d" />
        <Bar dataKey="Коровы" fill="#ffc658" />
        <Bar dataKey="Лошади" fill="#ff7300" />
        <Bar dataKey="Овцы" fill="#d0ed57" />
        <Bar dataKey="Свиньи" fill="#a4de6c" />
      </BarChart>
    </div>
  );
};

export default KRCandMRCChartSecond;
